import { loadStripe, Stripe } from '@stripe/stripe-js';

const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

let cached: Promise<Stripe | null> | null = null;

/**
 * Lazily load Stripe.js only when needed (not at module evaluation time).
 * Catches load failures (e.g. content blockers on iOS Safari) so the
 * rejection never goes unhandled.
 */
export function getStripePromise(): Promise<Stripe | null> {
  if (!key) return Promise.resolve(null);
  if (!cached) {
    cached = loadStripe(key).catch(() => {
      cached = null; // allow retry on next call
      return null;
    });
  }
  return cached;
}
